import styled from "styled-components";

import { colors } from "constants/theme";

const TableFoot = styled.tfoot`
  border-top: 1px solid ${colors.borders};
`;

export default TableFoot;
